import React from 'react';
import Can from "../Can";
import ReqLabPage from "./ReqLabPage";

function ReqLab(props) {
    var myHome;

    if (!props.apiAuthGroups) {
        myHome = (
            null
        )
    } else {
        myHome = (
            <Can
                role={props.apiAuthGroups}
                perform="labRequest-page:visit"
                yes={() => (
                    <ReqLabPage
                        apiAuthResponse={props.apiAuthResponse}
                        apiAuthName={props.apiAuthName}
                        apiAuthSurname={props.apiAuthSurname}
                        apiAuthGroups={props.apiAuthGroups}
                        labVersion={props.labVersion}
                    />
                )}
                no={() => (null)}
            />
        )
    }


    return myHome;
}

export default ReqLab;